module.exports = __webpack_public_path__ + "media/site_templates/www.polishingfloorboards.com.au/images/our_services_1-1aaf655ce6ccf9b8c5edb5130ca04bf0.jpg";